import 'services/GTM';
import { createApp } from 'vue';
import vueStatic from 'vue-static';

import E from 'services/emitter';
import { DEV, PROD, TEST, OS } from 'const';
import router from 'router';
import ROUTES from 'routes';

import 'styles/fonts.css';
import 'styles/vars.css';
import 'styles/main.css';
import 'styles/Checkbox.css';

// import * as UI from 'components/UI';
// import * as filters from 'sd-app/utils/formatters';
import Svgi from 'components/Svgi';
import Root from 'components/Root';

const app = createApp(Root);
app.use(router);
app.use(vueStatic);
// app.use(Notifications);
app.mixin({ mounted () { this.$el.__vue__ = this } });

// Object.entries(UI).forEach(([name, cmp]) => app.component(name, cmp));
app.component('Svgi', Svgi);

Object.assign(
  app.config.globalProperties,
  {
    $log: window.console.log,
    $root: app,
    ROUTES,
    DEV,
    TEST,
    PROD,
    isArr: Array.isArray,
    // flt: filters,
  },
);

app.mount('#ohm');

if (/*!DEV && */'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const firstInstall = !navigator.serviceWorker.controller;
    navigator.serviceWorker.register('/sw.js').then(
      reg => {
        window.console.log('Service Worker registered: ', reg);
        // show notify if any code updates detected
        reg.addEventListener('updatefound', e => {
          if (!firstInstall) {
            // E.emit('sw:updatefound', e);
            setTimeout(() => window.location.reload(), 200);
          }
        });
      },
      err => window.console.error('Service Worker error: ', err),
    );
  });
}

if (OS === 'iOS') (() => {
  const getViewHeight = require('ios-inner-height');
  function setRootVh () {
    document.documentElement.style.setProperty('--vh', `${ getViewHeight() }px`);
  }
  E.on('resize', setRootVh);
  setRootVh();
})();

// if (!PROD) {
//   const favicos = [...document.querySelectorAll('link[rel=icon]')];
//   favicos.forEach(ico => ico.id !== 'fav-dev' && document.head.removeChild(ico));
// }
